import React, { useState } from "react";
import { Link } from "react-router-dom";

const OrderConfirmed = () => {
  const [orderInput, setOrderInput] = useState("");
  const [status, setStatus] = useState(null);
  const [error, setError] = useState("");

  const handleTrack = (e) => {
    e.preventDefault();
    setError("");
    setStatus(null);

    const pattern = /^#[0-9]{5}$/; // must start with # + 5 digits
    if (!pattern.test(orderInput.trim())) {
      setError("Please enter a valid order ID (e.g., #12345).");
      return;
    }

    // Random statuses
    const possibleStatuses = [
      "Order Placed",
      "Order Processed",
      "Awaiting Shipment",
      "Payment Confirmed",
      "Packaging in Progress",
    ];

    const randomStatus =
      possibleStatuses[Math.floor(Math.random() * possibleStatuses.length)];

    setTimeout(() => {
      setStatus({
        id: orderInput.trim(),
        date: new Date().toLocaleDateString(),
        time: new Date().toLocaleTimeString(),
        status: randomStatus,
      });
    }, 700); // simulate API delay
  };

  return (
    <section className="order-track-section py-80">
      <div className="container text-center">
        <h2 className="order-track-title fw-bold mb-12">Track Your Order</h2>
        <p className="order-track-subtitle text-muted mb-4">
          Enter your order ID below to get the latest update
        </p>
        <p className="order-track-welcome text-gray-700 mb-40">
          Welcome back! Track your orders below.
        </p>

        <div className="order-track-box mx-auto p-32 rounded-8 shadow-sm border">
          <div className="order-track-header d-flex align-items-center mb-20">
            <i className="ph ph-magnifying-glass text-main me-2 text-xl"></i>
            <h5 className="fw-semibold mb-0 text-dark">Track Your Order</h5>
          </div>

          <form
            onSubmit={handleTrack}
            className="order-track-form d-flex align-items-center gap-6 flex-wrap"
          >
            <input
              type="text"
              value={orderInput}
              onChange={(e) => setOrderInput(e.target.value)}
              className="order-track-input flex-grow-1 rounded-8 px-16 py-12"
              placeholder="Enter order ID (e.g., #12345)"
            />
            <button
              type="submit"
              className="order-track-btn rounded-8 fw-semibold"
            >
              Track Order
            </button>
          </form>

          {error && <p className="text-danger mt-16 fw-semibold">{error}</p>}

          <p className="order-track-hint text-gray-600 mt-16">
            You can find your order number in your confirmation email. Try
            testing with IDs like <strong>#12345</strong>.
          </p>

          {status && (
            <div className="mt-32 border-top pt-24">
              <h6 className="text-dark fw-semibold mb-8">
                Order Status for {status.id}
              </h6>
              <p className="text-gray-700 mb-2">
                <strong>Status:</strong> {status.status}
              </p>
              <p className="text-gray-600">
                <strong>Last Updated:</strong> {status.date} at {status.time}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default OrderConfirmed;
